import { useMemo } from 'react';
import { useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router-dom';

import {
  HEADER_HEIGHT,
  HEADER_HEIGHT_ADDITIONAL,
  PROFILE_SUBNAV_HEIGHT,
} from '@/config/constants';
import { isLoanFlowPath } from '@/config/loanNavPaths';
import { useAuth } from './useAuth';

export const useAppLayout = () => {
  const { isAuthenticated } = useAuth();
  const isMobile = useMediaQuery('(max-width: 900px)');
  const location = useLocation();

  const showLoanSubnav = isAuthenticated && isLoanFlowPath(location.pathname);
  const showSecondarySubnav = showLoanSubnav;

  const headerHeight = useMemo(() => {
    let h = HEADER_HEIGHT;
    if (showSecondarySubnav) h += PROFILE_SUBNAV_HEIGHT;
    if (isMobile && isAuthenticated) h += HEADER_HEIGHT_ADDITIONAL;
    return h;
  }, [isMobile, isAuthenticated, showSecondarySubnav]);

  return {
    headerHeight,
    showLoanSubnav,
    showSecondarySubnav,
  };
};
